export enum HomestayProvider {
  Any = 'any',
  School = 'School',
  Educatius = 'Educatius',
  AustralianHomestayNetwork = 'Australian Homestay Network',
}
